import {useCallback, useEffect, useState} from "react";

function areObjectsEqual(obj1: any, obj2: Record<string, any>) {
    if (obj1 === obj2) return true;

    if (typeof obj1 !== "object" || typeof obj2 !== "object") {
        return false;
    }

    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
        return false;
    }

    for (const key of keys1) {
        if (!Object.prototype.hasOwnProperty.call(obj2, key)) {
            return false;
        }

        if (!areObjectsEqual(obj1[key], obj2[key])) {
            return false;
        }
    }

    return true;
}

export default function useIsModified(state: any) {
    const [initialState, setInitialState] = useState(null);
    const [isModified, setIsModified] = useState(false);

    useEffect(() => {
        if (initialState === null) {
            setInitialState(state);
        } else {
            setIsModified(!areObjectsEqual(initialState, state));
        }
    }, [initialState, state]);

    const updateCachedState = useCallback(() => {
        setInitialState(null);
    }, []);

    return {isModified, initialState, updateCachedState};
}